import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { vehicleNumberDisplay } from '../../../../utils/utils';
import { SteeringWheel } from '../../../../components/icons';
const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    height: 84,
    padding: "16px 24px",
    display: 'flex',
    justifyContent:'space-between',
    alignItems: 'center',
    backgroundColor:'#fff',
    cursor:'pointer'
  },
  icon:{
    fontSize:52,
    color:'#000'
  },
  iconDirection:{
    fontSize:24,
    color:'#03c'
  },
  info:{
    display:'flex',
    alignItems:'center'
  },
  driverInfo:{
    marginLeft:24
  },
  driverLabel:{
    fontSize:14,
    color:'#636872',
    marginBottom:8
  },
  driverName:{
      color:'#0b1323',
      fontWeight:600,
      fontSize:18,
      marginBottom:0,
  }
}));
const JourneyDriverCard = (props) => {
  const {driver} = props;
  const classes = useStyles();
  let history = useHistory();
  const goToDriverView = () => {
    if (driver && driver.driverId && !driver.isDriverDeleted) {
      const driverId = driver.driverId;
      const driverName = driver.driverName;
      const status = driver.status ? driver.status : '';
      history.push({
        pathname: `/drivers/single-driver/${driverId}`,
        state: {
          id: 8,
          driverStatus: status || null,
          pageTitle: driverName ? driverName : 'Driver View',
          driverId: driverId
        }
      });
    }
  }
  return (
    <>
      <Paper component='div' className={classes.card} onClick={goToDriverView}>
        <div className={classes.info}>
          <SteeringWheel className={classes.icon} />
          <div className={classes.driverInfo}>
            <Typography className={classes.driverLabel}>Driver Name</Typography>
            <Typography className={classes.driverName}>{driver&&driver.driverName?driver.driverName:''}</Typography>
          </div>      
        </div>
        <ChevronRightIcon className={classes.iconDirection} />
      </Paper>
    </>
  );
}
export default JourneyDriverCard;